import { ORDERS_STATUS_MESSAGES, OrdersStatusMessages } from "./order-status.messages";
import { POPOVER_MESSAGES, PopoverMessages } from "../popover.messages";
import { TABLE_COLUMNS_MESSAGES, TableColumnsMessages } from "../tables/columns.messages";

export type OrdersTableMessages = TableColumnsMessages &
  PopoverMessages &
  OrdersStatusMessages & {
    // Error Messages
    orderNotFoundError: string;
    orderNotFoundDescription: string;
    orderNotFoundAlt: string;
    orderErrorToLoad: string;

    // Title Messages
    orderTableTitle: string;

    // Columns Messages
    salesChannelColumn: string;
    orderNumberColumn: string;
    integratedColumn: string;
    buyerColumn: string;
    statusColumn: string;
    dateColumn: string;
    orderAmount: string;

    // Row Messages
    integrationTrue: string;
    integrationFalse: string;

    // Receipt Messages
    paymentReceiptTitle: string;
    cancellationReceiptTitle: string;
    cancellationFormTitle: string;
  };

export const ORDERS_TABLE_MESSAGES: OrdersTableMessages = {
  ...TABLE_COLUMNS_MESSAGES,

  // Error Messages
  orderNotFoundError: "Pedido não encontrado",
  orderNotFoundDescription: "Descrição do pedido não encontrado",
  orderNotFoundAlt: "Pedido não encontrado alternativa",
  orderErrorToLoad: "Erro ao carregar o pedido",

  // Title Messages
  orderTableTitle: "Listagem de Pedidos",

  // Columns Messages
  salesChannelColumn: "Canal de Vendas",
  orderNumberColumn: "Número do Pedido",
  integratedColumn: "Integração",
  buyerColumn: "Cliente",
  statusColumn: "Status",
  dateColumn: "Data",
  orderAmount: "Valor",

  // Row Messages
  integrationTrue: "Sim",
  integrationFalse: "Não",

  // Receipt Messages
  paymentReceiptTitle: "Comprovante de Pagamento",
  cancellationReceiptTitle: "Comprovante de Cancelamento",
  cancellationFormTitle: "Formulário de Cancelamento",

  ...POPOVER_MESSAGES,
  ...ORDERS_STATUS_MESSAGES,
};
